/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homecontributetext2Inputs */



/**
* | output |
* | --- |
* | "MUNify DELEGATOR is open source. Browse the code, report bugs or bring your own ideas." |
*
* @param {Homecontributetext2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homecontributetext2 = /** @type {((inputs?: Homecontributetext2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homecontributetext2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("MUNify DELEGATOR is open source. Browse the code, report bugs or bring your own ideas.")
	return /** @type {LocalizedString} */ ("MUNify DELEGATOR ist Open Source. Schau dir den Code an, melde Fehler oder bring eigene Ideen ein.")
});
export { homecontributetext2 as "homeContributeText" }